<template>
  <CCol col="8" :md="{ offset: '2' }">
    <CCard>
      <CCardHeader color="dark" class="text-white"> Formação </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol col="6">
            <CInput
              label="Nome"
              v-model.trim="form.name"
              :isValid="isValid('name')"
              :invalidFeedback="errorMessage('name')"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol col="2">
            <label>Visível Global</label>
            <br />
            <CSwitch
              color="primary"
              :checked.sync="form.visible_global"
              variant="opposite"
            />
          </CCol>
          <CCol col="2">
            <label>Visível Inscritos</label>
            <br />
            <CSwitch
              color="primary"
              :checked.sync="form.visible_subscribers"
              variant="opposite"
            />
          </CCol>
          <CCol col="2">
            <label>Aceita Inscrição</label>
            <br />
            <CSwitch
              color="primary"
              :checked.sync="form.allows_subscription"
              variant="opposite"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol col="6">
            <label>Perfis</label>
            <v-select :options="roles" multiple v-model="form.roles"></v-select
            ><br />
          </CCol>
          <CCol col="6"> </CCol>
        </CRow>

        <CRow>
          <CCol col="12">
            <label>Descrição da Formação</label>
            <ckeditor
              :editor="editor"
              v-model="form.description"
              :config="editorConfig"
              tag-name="textarea"
            >
            </ckeditor>
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter>
        <CRow>
          <CCol col="2">
            <CButton color="danger" @click="cancel">Cancelar</CButton>
          </CCol>
          <CCol col="2" :md="{ offset: '8' }" style="text-align: right">
            <CButton color="primary" @click="save">Salvar</CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
  </CCol>
</template>

<script>
import vSelect from "vue-select";
import { Cropper } from "vue-advanced-cropper";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import HeadingPlugin from "@ckeditor/ckeditor5-heading/src/heading";
import AlignmentPlugin from "@ckeditor/ckeditor5-alignment/src/alignment";
import FontColorPlugin from "@ckeditor/ckeditor5-font/src/fontcolor";
import FontFamilyPlugin from "@ckeditor/ckeditor5-font/src/fontfamily";
import FontSizePlugin from "@ckeditor/ckeditor5-font/src/fontsize";
import MediaEmbedPlugin from "@ckeditor/ckeditor5-media-embed/src/mediaembed";
import TablePlugin from "@ckeditor/ckeditor5-table/src/table";

import { myHelper } from "../../assets/helpers/helper.js";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  name: "Formation",
  components: {
    ckeditor: CKEditor.component,
    vSelect,
  },

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          HeadingPlugin,
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          AlignmentPlugin,
          MediaEmbedPlugin,
          FontColorPlugin,
          FontFamilyPlugin,
          FontSizePlugin,
          TablePlugin,
        ],
        toolbar: {
          items: [
            "fontFamily",
            "fontSize",
            "fontColor",
            "heading",
            "|",
            "bold",
            "italic",
            "|",
            "alignment:left",
            "alignment:right",
            "alignment:center",
            "alignment:justify",
            "|",
            "mediaEmbed",
            "link",
            "undo",
            "redo",
            "|",
            "insertTable",
          ],
        },
        mediaEmbed: {
          previewsInData: true,
        },
      },
      form: {
        name: "",
        description: "",
        visible_global: true,
        visible_subscribers: true,
        allows_subscription: true,
        image: null,
        imageInt: null,
        roles: [],
      },
      roles: [],
      formErrors: {},
      mode: 0,
      errorMessages: {
        name: {
          required: "Nome é obrigatório",
          minLength: "O nome precisa ter ao menos 4 caracteres",
        },
      },
    };
  },

  validations() {
    let validate = {
      form: {
        name: {
          required,
          minLength: minLength(4),
        },
        description: {
          required,
        },
      },
    };
    return validate;
  },

  created() {
    this.$loading(true);
  },

  mounted() {
    this.$http
      .get("/api/roles")
      .then((res) => {
        if (res.status === 200) {
          this.roles = res.data.roles;
          for (let index = 0; index < this.roles.length; index++) {
            this.roles[index].label = myHelper.translateRole(
              this.roles[index].label
            );
          }
        }
      })
      .catch((error) => {});

    if (this.$route.params.id > 0) {
      this.$http
        .get("/api/formations/" + this.$route.params.id)
        .then((res) => {
          if (res.status === 200) {
            this.form = res.data.formation;

            for (let index = 0; index < this.form.roles.length; index++) {
              this.form.roles[index].label = myHelper.translateRole(
                this.form.roles[index].label
              );
            }

            if (this.form.image !== null) {
              this.hasImage = true;
            }

            if (this.form.image_int !== null) {
              this.hasImageInt = true;
              this.form.imageInt = this.form.image_int;
            }

            this.$v.$touch();
            this.$loading(false);
          }
        })
        .catch((error) => {});
    } else {
      this.$loading(false);
      this.$v.$touch();
    }
  },

  methods: {
    pixelsRestriction({
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      imageWidth,
      imageHeight,
    }) {
      return {
        minWidth: 550,
        minHeight: 250,
        maxWidth: 550,
        maxHeight: 250,
      };
    },

    save() {
      this.formErrors = {};
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$loading(true);
        const formData = new FormData();

        this.form.roles = this.form.roles == undefined ? [] : this.form.roles;

        formData.append("name", this.form.name);
        formData.append("description", this.form.description);
        formData.append("visible_global", this.form.visible_global);
        formData.append("visible_subscribers", this.form.visible_subscribers);
        formData.append("allows_subscription", this.form.allows_subscription);
        formData.append("roles", JSON.stringify(this.form.roles));

        if (this.$route.params.id == 0) {
          this.send("post", "/api/formations", formData);
        } else {
          formData.append("_method", "PUT");
          this.send(
            "post",
            "/api/formations/" + this.$route.params.id,
            formData
          );
        }
        this.$loading(false);
      }
    },

    send(method, to, formData) {
      this.$http({
        method: method,
        url: to,
        data: formData,
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.code === 0) {
              let msg =
                this.$route.params.id > 0
                  ? "Formação alterada com sucesso!"
                  : "Formação adicionada com sucesso!";
              this.$swal({
                icon: "success",
                title: msg,
              });
              this.$router.push({ path: "/formations" });
            }
          } else {
            this.formErrors = res.data.errors;
          }
        })
        .catch((error) => {
          this.$swal({
            icon: "danger",
            title: msg,
          });
        });
    },

    cancel() {
      this.$swal({
        icon: "warning",
        title: "Atenção",
        text: "Deseja realmente cancelar?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ path: "/formations" });
        }
      });
    },

    loadImage(event, i) {
      var input = event.target;

      if (input.files && input.files[0]) {
        var reader = new FileReader();
        if (i === 0) {
          reader.onload = (e) => {
            this.image = e.target.result;
          };
        } else {
          reader.onload = (e) => {
            this.imageInt = e.target.result;
          };
        }
        reader.readAsDataURL(input.files[0]);
      }
    },

    isValid: function (k) {
      let ret =
        this.$v.form[k].$error !== undefined ? !this.$v.form[k].$error : true;
      if (this.formErrors !== undefined) {
        if (this.formErrors[k] !== undefined) {
          ret = false;
        }
      }

      return ret;
    },
    errorMessage: function (k) {
      if (this.formErrors[k] === undefined) {
        let v = this.$v.form[k];
        let obj = Object.keys(v);

        for (let i = 0; i < obj.length - 8; i++) {
          if (!v[obj[i]])
            if (this.errorMessages[k] !== undefined)
              return this.errorMessages[k][obj[i]] !== undefined
                ? this.errorMessages[k][obj[i]]
                : "Verifique o valor informado";
        }
      } else {
        return this.formErrors[k][0];
      }
    },
  },
};
</script>
<style scoped>
.course-card > header {
  text-align: center;
  font-weight: 600;
}
.course-card .card-body {
  min-height: 20vh;

  padding: 0;
}
.course-card > footer {
  padding: 0;
}
</style>
<style>
.ck-editor__editable {
  min-height: 250px;
}
.upload-imagem-cropper {
  background-color: rgb(231, 231, 231);
  border: dashed 1px rgb(121, 120, 120);
  height: 252px;
  width: 100%;
}

.button-wrapper,
.button-wrapper-remove {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button-wrapper > .button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  background: #3fb37f;
  cursor: pointer;
  transition: background 0.5s;
}

.button-wrapper-remove > .button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  background: #e55353;
  cursor: pointer;
  transition: background 0.5s;
}

.button-wrapper > .button:hover {
  background: #38d890;
}

.button-wrapper-remove > .button:hover {
  background: #df0f0f;
}

.button input {
  display: none;
}

@media (max-width: 575px) {
  .col-2 {
    flex: none;
    max-width: 100%;
  }
  .card-footer .col-2 {
    max-width: 50%;
  }
  .col-6 {
    flex: none;
    max-width: 100%;
  }
  .col-8 {
    max-width: 100% !important;
  }
}
</style>
